<div *ngIf="program | async; let program" class="program-event" 
	[ngStyle]="{'line-height':'0.8em','margin':'0','padding':'0 0 0 3px'}">
	 	<span *ngFor="let composition of program;let i=index" class="program-name">
				<span *ngIf="checkNextComposer(composition,program[i-1])">
					{{ composition.composerlastname }} &nbsp;&nbsp;
				</span>
		</span>
</div>